import React, { useMemo } from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';

import { useColors } from '../../../../hooks';
import ThemedText2 from '../../../themed-text-2';

interface VocabularyDisplayProps {
  vocabulary?: string;
}

export default function VocabularyDisplay({
  vocabulary,
}: VocabularyDisplayProps) {
  const colors = useColors();
  const screenWidth = Dimensions.get('window').width;

  const wordContainerWidth = useMemo(() => {
    if (screenWidth < 600) {
      return '50%';
    }
    return '33%';
  }, [screenWidth]);

  const words = useMemo(() => {
    return vocabulary?.split(',').map((word) => word.trim());
  }, [vocabulary]);

  return (
    <View style={styles.container}>
      {words?.map((word) => (
        <View
          key={word}
          style={[styles.wordContainer, { width: wordContainerWidth }]}
        >
          <View style={[styles.dot, { backgroundColor: colors.borderColor }]} />
          <ThemedText2 fontSize={20} style={styles.word} fontWeightStyle="bold">
            {word}
          </ThemedText2>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  wordContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 6,
    flexShrink: 1,
  },
  word: {
    flexGrow: 1,
    flexWrap: 'wrap',
    maxWidth: '95%',
  },
  dot: {
    width: 4,
    height: 4,
    borderRadius: 4,
    marginRight: 8,
  },
});
